<template>
	<div class="w1">
	<div  class="DigitalEconomy_wrapper"><!-- DigitalEconomy_wrapper -->
		<el-skeleton :rows="20" :loading="loadingMask" animated>
			<template>
				<div class="DigitalEconomy_top"><h1>民间投资</h1></div>
				
				
				<div class="group2b"><!-- group2b -->
					<div class="group2b_L"><!-- group2b_L -->
					
						<div class="report_nav_wrap"><!-- report_nav_wrap -->
							<div  class="report_nav_h"  :class="colid?'':'on'" >
								<i class="cei-icon icon-report"></i>
								<a @click="selcol('')">内容纵览</a>
							</div>
							<div class="report_nav"><!-- report_nav -->
								<dl v-for="(item,index) in menuColArr">
									<dt>
										<a :class="ztTabsId==item.id?'on':''" @click="selcol(item.id,item.name,(item.sub?2:1))" >{{item.name}}</a>
									</dt>
									<dd v-if="item.sub" v-for="(sitem,sindex) in item.sub">
										<a :class="ztTabsId==sitem.id?'on':''" @click="selcol(sitem.id,sitem.name)" >{{sitem.name}}</a>
									</dd>
								</dl>
							</div><!-- /report_nav -->
						</div><!-- /report_nav_wrap -->
				
					</div><!-- /group2b_L -->
					
					<ztmyjjlist v-if="ztTabsId&&ztTabsType!=2" v-bind:colid="ztTabsId" v-bind:colname="ztTabsName" v-bind:sourcecol="sourcecol"></ztmyjjlist>
					
					<ztmyjjindex v-else v-bind:indextype="ztTabsType" v-bind:colarr="menuColArr" v-bind:sourcecol="sourcecol" @changecol="selcol"></ztmyjjindex>
					
				</div><!-- /group2b -->
					
				
				
				
				<div class="m_b1"></div>
			</template>
		</el-skeleton>
						
					
					
					
	</div><!-- /DigitalEconomy_wrapper -->
	</div>
</template>

<script>
	import ztmyjjindex from '@/components/ztmyjj-index.vue'
	import ztmyjjlist from '@/components/ztmyjj-list.vue'
	export default {
		data() {
			return {
				loadingMask: false,
				sourcecol:'ztminyingjingji',
				colid:'',
				colname:'',
				ztTabsId:'',
				ztTabsName:'',
				ztTabsType:1,
				menuColArr:[
					{
						id:'a986f9795d934dc9b74ebac4efbef1dc',
						name:'国家部署'
					},
					{
						id:'e92a2dcd7cd74b72b10094f63c4b4a4c',
						name:'省市政策'
					},
					{
						id:'191336fd4e2a44c9985ff2ca8ad1bf64',
						name:'地方推进',
						sub:[
							{
								id:'c66c6708b6bd4862ac6cb5f055a7f598',
								name:'项目'
							},
							{
								id:'d995a79af8174341addf91b67d1e6ce2',
								name:'投融资'
							},
							{
								id:'9f8adadb7595491bb23f6dd0088d3e4a',
								name:'要素支持'
							},
							{
								id:'01e9217ee5bd405eae08ec8696fba2dd',
								name:'营商环境'
							},
						]
					},
					{
						id:'b60281850b054ca5adabe960ccf4e3c7',
						name:'前瞻观点'
					},
				]
			}
		},
		components:{
			ztmyjjindex,
			ztmyjjlist
		},
		watch: {
			
		},
		mounted: function() {
			document.title='民间投资-中经专网';
			this.$track([
				['pagetype','民间投资专题'],
				['reqtype','2'],
				['column','ac6fdec210f74c318c52a6aba07661e6']
			]);
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			selcol:function(selid,selname,seltype){
				this.ztTabsId=selid;
				this.ztTabsName=selname;
				if(seltype==2){
					this.ztTabsType=2;
				}
				else{
					this.ztTabsType=1;
				}
				this.$track([
					['pagetype','民间投资专题子栏目'],
					['reqtype','2'],
					['column',this.ztTabsId]
				]);
			},
			
		}
	}
</script>

<style>
</style>
